import { View } from 'backbone.marionette';

import DocumentDownloadTypes from '@/enums/DocumentDownloadTypes';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import { formatDisplayDate } from '@/util/MomentUtils';
import downloadDocument from '@/util/downloadDocument';

import GenerateOrderSummary from '../../../order/services/GenerateOrderSummary';

import tmplOrderSummaryAttachmentView from './OrderSummaryAttachmentView.hbs';

const OrderSummaryAttachmentView = View.extend({
  template: tmplOrderSummaryAttachmentView,

  className: 'order-summary-attachment',

  ui: {
    attachmentView: '.order-summary-attachment-view',
    generateButton: '.btn-upload',
    generatedOnDate: '#generatedOnDate',
    fileName: '#fileName'
  },

  regions: {
    attachmentView: '@ui.attachmentView'
  },

  events: {
    'click @ui.generateButton': 'onClickGenerateButton',
    'click @ui.fileName': 'onClickFileName'
  },

  async onClickGenerateButton(e) {
    e.preventDefault();
    let newOrderSummary;
    try {
      newOrderSummary = await GenerateOrderSummary(this.model.get('orderId'));
      this.model.set('newAttachmentId', newOrderSummary.attachmentId);
      this.model.set('newFileName', newOrderSummary.fileName);
      this.ui.fileName.text(this.model.get('newFileName'));
      this.ui.generatedOnDate.val(formatDisplayDate(new Date()));
    } catch (e) {
      this.showGenerationError();
    } finally {
      this.showGenerationSuccess();
    }
  },

  onClickFileName(e) {
    e.preventDefault();
    const attachment = this.model.get('attachment');
    downloadDocument({
      attachmentId: this.model.get('newAttachmentId') ? this.model.get('newAttachmentId') : attachment.id,
      fileName: this.model.get('newFileName') ? this.model.get('newFileName') : attachment.fileName,
      downloadType: DocumentDownloadTypes.ATTACHMENT
    });
  },

  showGenerationError() {
    showErrorMessage({
      errorCode: 'fileGenerationError',
      errorTitle: 'File Generation Error',
      errorMessage: 'Error Generating File.'
    });
  },

  showGenerationSuccess() {
    showSuccessMessage({
      code: 'fileGenerationSuccess',
      title: 'File Generation Success',
      message: 'The newly generated order summary is ready to download.'
    });
  }
});

export default OrderSummaryAttachmentView;
